import { SituationsModel } from '@shared/models/situations.model';
import { CameraModel } from '@shared/models/camera.model';
import { Co2Model } from '@shared/models/co2.model';
import { TrafficSpeedRangeModel } from './traffic-speed-range.model';
import { BicyclePathModel } from '@shared/models/bicycle-path.model';
import { ParkingLotModel } from '@shared/models/parking-lot.model';
import { TrafficLightModel } from '@shared/models/traffic-light.model';
import { AgentsModel } from '@shared/models/agents.model';
import { AgentsHistoricalModel } from '@shared/models/agents-historical.model';
import { TrafficManagmentPlansPathModel } from '@shared/models/trafficmanagmentplans-path.model';
import { StopBusModel } from './stopbus.model';
import { ZonesPathModel } from './zones-path.model';
import { RoadRunPathModel } from './roadrun-path.model';
import { AccidentModel } from './accident.model';
import { PmvModel } from './pmv.model';
import { MatrixODModel } from '@shared/models/matrixOD.model';
import { AirQualityModel } from '@shared/models/air_quality/AirQuality.model';
import { ParkingSpotModel } from './parking-spot.model';
import { ParkingLoadingZoneModel } from './parking-loading-zone.model';
import { MatrixODCameraModel } from './matrixOD.Cameras.model';
import { PanicButtonModel, ParkingLineModel } from '@shared/models/parking-line.model';
import { CameraPointsModel } from './cameraPoint.model';
import { LuminaryModel } from './luminary.model';
import { GarbageModel } from './garbage.model';

export enum GeoAPITypeEnum {
  Camera                    = 'Camera',
  Situation                 = 'Situation',
  Traffic                   = 'Traffic',
  Blank                     = 'Blank',
  Co2                       = 'Co2',
  Aforo                     = 'Aforo',
  TrafficConcordance        = 'TrafficConcordance',
  TrafficSpeedRange         = 'TrafficSpeedRange',
  BicyclePath               = 'BicyclePath',
  ParkingLot                = 'ParkingLot',
  TrafficLight              = 'TrafficLight',
  Agents                    = 'Agents',
  AgentsHistorical          = 'AgentsHistorical',
  TrafficManagmentPlans     = 'TrafficManagmentPlans',
  StopBus                   = 'StopBus',
  RouteBus                  = 'RouteBus',
  Zones                     = 'Zones',
  MatrixODsensor            = 'MatrixOD',
  MatrixODcamera            = 'MatrixODcamera',
  RoadRun                   = 'RoadRun',
  Accident                  = 'Accident',
  Pmv                       = 'Pmv',
  PmvEditar                 = 'PmvEditar',
  PmvConsulta               = 'PmvConsulta',
  RuntDatex                 = 'RuntDatex',
  Skateboards               = 'Skateboards',
  ParkingZone               = 'ParkingZone',
  ParkingSpot               = 'ParkingSpot',
  ParkingSpotBGZones        = 'ParkingSpotBGZones',
  ParkingSpotLUZone         = 'ParkingSpotLUZone',
  ParkingLine               = 'ParkingLine',
  ParkingUnderground        = 'ParkingUnderground',
  ParkingLoadingZone        = 'parkingLoadingZone',
  PanicButton               = 'PanicButton',
  ResourcesAirQualityPoints = "ResourcesAirQualityPoints",
  ParkingSquareZones        = 'ParkingSquareZones',
  CameraPoints              = 'CameraPoints',
  Luminary                  = 'Luminary',
  Garbage                   = 'Garbage',
}


export enum FilterType {
  GEOCODE = 'geocode',
  ADDRESS = 'address',
  ESTABLISHMENT = 'establishment',
}


export type GeoAPIType =
  | CameraModel
  | SituationsModel
  | Co2Model
  | TrafficSpeedRangeModel
  // | BicyclePathModel
  | ParkingLotModel
  | TrafficLightModel
  | AgentsModel
  | TrafficManagmentPlansPathModel
  | StopBusModel
  | AgentsHistoricalModel
  | ZonesPathModel
  | RoadRunPathModel
  | AccidentModel
  | PmvModel
  | MatrixODModel
  | MatrixODCameraModel
  | AirQualityModel
  | ParkingSpotModel
  | ParkingLineModel
  | ParkingLoadingZoneModel
  | CameraPointsModel
  | PanicButtonModel
  | LuminaryModel
  | GarbageModel;
